import { forwardRef } from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { useDialogScrollNavigation } from './use-dialog-scroll-navigation';
import { VStack } from '../../stack/stack.styled';
import {
  Arrow,
  NavigationWrapper,
  StyledContent,
  StyledNavigation,
  StyledOverlay,
} from '../dialog.styled';
import { Icons } from 'assets';
import { SVG } from '../../../svg/svg';

import {
  isSafeOutsideTarget,
  useTinyMceDialogLayer,
} from './dialog-outside-guard';

export const Content = forwardRef<
  HTMLDivElement,
  RadixDialog.DialogContentProps & { withScrollArrows?: boolean }
>((props, forwardedRef) => {
  const { children, withScrollArrows = true, ...radixContentProps } = props;

  useTinyMceDialogLayer();

  const {
    topAnchorRef,
    bottomAnchorRef,
    isTopVisible,
    isBottomVisible,
    scrollTo,
  } = useDialogScrollNavigation();

  return (
    <StyledOverlay id="dialog-overlay">
      <StyledContent
        {...radixContentProps}
        ref={forwardedRef}
        onPointerDownOutside={(event) => {
          if (isSafeOutsideTarget(event.target)) {
            event.preventDefault();
          }
        }}
      >
        <VStack flex={1}>
          <div id="dialog-top-anchor" ref={topAnchorRef} />
          {children}
          <div id="dialog-bottom-anchor" ref={bottomAnchorRef} />
        </VStack>

        <NavigationWrapper>
          <StyledNavigation>
            <RadixDialog.Close asChild>
              <div>
                <SVG src={Icons.Cross} props={{ size: '24px' }} />
              </div>
            </RadixDialog.Close>

            {withScrollArrows && (
              <VStack>
                <Arrow $isShown={!isTopVisible} onClick={() => scrollTo('top')}>
                  <SVG
                    src={Icons.ArrowLeft}
                    props={{ deg: 90, size: '24px' }}
                  />
                </Arrow>
                <Arrow
                  $isShown={!isBottomVisible}
                  onClick={() => scrollTo('bottom')}
                >
                  <SVG
                    src={Icons.ArrowLeft}
                    props={{ deg: -90, size: '24px' }}
                  />
                </Arrow>
              </VStack>
            )}
          </StyledNavigation>
        </NavigationWrapper>
      </StyledContent>
    </StyledOverlay>
  );
});
